export default "__VITE_ASSET__DSJQrfeY__"